import * as React from 'react';
import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';

import Loader from '../Loader';
import CopyToClipboardStore from './Store';
import CopyIcon from '../Cutesies/CopyIcon';
import Checkmark from '../Cutesies/Checkmark';

export interface Props {
  store: CopyToClipboardStore;
}

const CopyToClipboardState: React.FC<Props> = ({ store }) => {
  switch (store.state.kind) {
    case 'waiting':
      return (
        <span onClick={() => store.copying()} className="cursor-pointer">
          <CopyIcon />
        </span>
      );
    case 'copying':
      return (
        <div className="h-6 w-6">
          <Loader type="spin" text={nothing()} height={24} width={24} color="#187A90" />
        </div>
      );
    case 'copied':
      return (
        <div className="flex h-6 w-6 items-center">
          <Checkmark className="fill-teal-600" />
        </div>
      );
  }
};

export default observer(CopyToClipboardState);
